import { AsyncResult, callActionOrExecute, Cart, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import * as DataServiceEntities from './delivery-date-data';

function getDeliveryDatesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getDeliveryDatesInput(location: number, cart: Cart, callerTime: Date, dlvMode?: string): IDataServiceRequest {
    const query = getDeliveryDatesQuery();
    return query.createDataServiceRequestForOperation(
        'GetDeliveryDates',
        true,
        DataServiceEntities.DeliveryDateDataExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IDeliveryDateData'
        },
        {
            location: location,
            cart: cart,
            callerTime: callerTime,
            dlvMode: dlvMode || ''
        }
    );
}

export function getDeliveryDatesAsync(context: IContext, location: number, cart: Cart, callerTime: Date, dlvMode?: string): AsyncResult<DataServiceEntities.IDeliveryDateData> {
    const request = getDeliveryDatesInput(location, cart, callerTime, dlvMode);
    return callActionOrExecute<DataServiceEntities.IDeliveryDateData>(request, context.callerContext);
}